import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { forgotPassword } from '../api/Authapi';
import './ForgotPassword.css';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const response = await forgotPassword(email);
      setSuccess(response.data.message);
      
      // Navigate to verify code page after 2 seconds
      setTimeout(() => {
        navigate('/verify-reset-code', { state: { email } });
      }, 2000);
    } catch (err) {
      setError(err.response?.data?.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='forgot-password-form-container'>
      <form className='forgot-password-form' onSubmit={handleSubmit}>
        <div>
          <h3>Forgot Password</h3>
          <p>Enter your email address and we'll send you a reset code.</p>
        </div>

        {error && <div className="error-message">{error}</div>}
        {success && <div className="success-message">{success}</div>}

        <div className="input-container">
          <label htmlFor="email">Email Address</label>
          <input 
            type="email"
            className="form-input"
            id="email" 
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your registered email" 
            required
          />
        </div>

        <button type="submit" className="forgot-password-form-button" disabled={loading}>
          {loading ? 'Sending...' : 'Send Reset Code'}
        </button>

        <div className="login-link">
          <button 
            type="button" 
            onClick={() => navigate('/login')} 
            className="forgot-password-link-button"
          >
            Back to Login
          </button>
        </div>
      </form>
    </div>
  );
};

export default ForgotPassword;